import React from 'react';
import dayjs from 'dayjs';

import CheckIcon from '@material-ui/icons/Check';
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import TodayIcon from '@material-ui/icons/Today';
import PersonIcon from '@material-ui/icons/Person';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import { tariffs } from '../../billing/timesheets/BillingTariff';

const formatDateRange = (dateFrom, dateTo) => {
    const separator = dateFrom && dateTo ? ' - ' : '';
    return `${dateFrom && dayjs(dateFrom).format('ddd D MMM')}${separator}${dateTo && dayjs(dateTo).format('ddd D MMM')}`;
}

const FunkyListItem = ({ primary, secondary = '', icon }) => {
    return (
        <ListItem>
            <ListItemAvatar>
                <Avatar>
                    {icon}
                </Avatar>
            </ListItemAvatar>
            <ListItemText primary={primary} secondary={secondary} />
        </ListItem>
    );
}

const ReferralView = ({ referral, referrer, request, notes = {}, courtCase }) => {

    const referringUser = referrer ?? referral.referrer;
    
    return (
        <div >
            <Typography variant="h6" color="textSecondary">Referral Details</Typography>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1} style={{ marginTop: '1rem', }}>
                <Grid item container xs={12} spacing={2}>
                    <Grid item><Typography variant="subtitle2">Booking Reference </Typography></Grid>
                    <Grid item><Typography variant="subtitle2" color="textSecondary">{referral.bookingReference}</Typography></Grid>
                </Grid>
                <Grid item container xs={12} spacing={2}>
                    <Grid item><Typography variant="subtitle2">Court Case Number</Typography></Grid>
                    <Grid item><Typography variant="subtitle2" color="textSecondary">{courtCase.courtCaseNumber}</Typography></Grid>
                </Grid>
                {
                    referral.tariff &&
                    <Grid item container xs={12} spacing={2}>
                        <Grid item><Typography variant="subtitle2">Jurisdiction</Typography></Grid>
                        <Grid item><Typography variant="subtitle2" color="textSecondary">{tariffs.get(referral.tariff)?.description}</Typography></Grid>
                    </Grid>

                }
                <Grid item xs={12}><Typography variant="subtitle2">Referred by</Typography></Grid>
            </Grid>
            <List>
                <FunkyListItem primary={referringUser.name} secondary={request.organization} icon={<PersonIcon />} />
                <FunkyListItem primary={referringUser.phoneNumber} secondary='Referrer contact number' icon={<PhoneAndroidIcon />} />
                <FunkyListItem primary={referringUser.email} secondary='Referrer email' icon={<AlternateEmailIcon />} />
                <FunkyListItem primary={referral.location?.name} secondary='Primary service location' icon={<HomeWorkIcon />} />
            </List>
            <div style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                <Typography variant="subtitle2">Timescales</Typography>
                <Typography variant="body2">{notes?.dates?.text || 'To be determined'}</Typography>
            </div>
            {
                referral.services && <React.Fragment>
                    <Typography variant="subtitle2">Services Required</Typography>
                    <List>
                        {
                            referral.services
                                .filter(svc => svc.quantity > 0)
                                .map(svc => {

                                    const description = [];

                                    if (svc.fromDate && svc.toDate) {
                                        description[0] = formatDateRange(svc.fromDate, svc.toDate);
                                    }
                                    else if (svc.fromDate) {
                                        description[0] = "On (or after) " + dayjs(svc.fromDate).format('ddd D MMM');
                                    }
                                    else if (svc.toDate) {
                                        description[0] = "By (or before) " + dayjs(svc.toDate).format('ddd D MMM');
                                    }
                                    else description[0] = '';

                                    // hackety-hack - on referrals the referrer isn't allowed to specify a quantity other than 1 or 0 for assessment & report (QUIQR)
                                    description[1] = svc.key !== 'QUIQR' && svc.key !== 'ADMINX' ? `${svc.quantity} ${svc.measure}${svc.quantity > 1 && 's'}` : `required`;

                                    if (svc.note) description.push(svc.note);

                                    return (
                                        <ListItem key={svc.key}>
                                            <ListItemAvatar>
                                                <Avatar>
                                                    <TodayIcon />
                                                </Avatar>
                                            </ListItemAvatar>
                                            <ListItemText
                                                primary={svc.description}
                                                secondary={description.join(' - ').trim()} />
                                        </ListItem>
                                    );
                                })
                        }
                    </List>
                </React.Fragment>
            }
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1} style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                <Grid item><Typography variant="subtitle2">Vulnerable Person</Typography></Grid>
                <Grid item><Typography variant="subtitle2" color="textSecondary">{courtCase.serviceUserName || 'Unspecified'}</Typography></Grid>
                <Grid item><Typography variant="subtitle2">Age</Typography></Grid>
                <Grid item><Typography variant="subtitle2" color="textSecondary">{referral.client?.age || 'Unspecified'}</Typography></Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
                <Typography variant="subtitle2">Vulnerabilities</Typography>
                <div style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                    {
                        referral.vulnerabilities?.map(v => {
                            return <Grid key={v.id} container direction="row" justify="flex-start" alignItems="center" spacing={1} >
                                <Grid item><CheckIcon fontSize="small" /></Grid>
                                <Grid item><Typography variant="body2">{v.description}</Typography></Grid>
                            </Grid>
                        })
                    }
                </div>
                {/* <Typography variant="body2" >{referral.vulnerabilities?.map(v => v.description).join(', ')}</Typography> */}
                {
                    notes.clientNeeds && <React.Fragment>
                        <Typography variant="subtitle2">Additional Vulnerability Information</Typography>
                        <Typography variant="body2">{notes.clientNeeds?.text}</Typography>
                    </React.Fragment>
                }

            </div>


        </div>
    );
};

export default ReferralView;